import React from 'react';

function TermsOfUse() {

    return (
        <div className='terms-of-use'>
            <h1>Terms and Conditions for Regional Ambassador Participation</h1>
            <p>Welcome to the DocPro Regional Ambassador Program. By participating in this program, you agree to the following terms and conditions. Please read them carefully before accepting.</p>

            <div className='para-section'>
                <h2>1. Scope of Participation</h2>
                <p>By agreeing to these terms, you, as a healthcare professional (HCP), voluntarily agree to:</p>
                <ol>
                    <li>1.1 Participate in prescription behavior studies related to gastroenterology for PrismPro.</li>
                    <li>1.2 Contribute to market research projects conducted by DocPro.</li>
                    <li>1.3 Be part of educational content creation, such as providing input for videos, interviews, or written materials as required.</li>
                    <li>1.4 Participate in specific programs or activities as requested by DocPro, with prior communication and mutual agreement.
                    </li>
                </ol>
            </div>

            <div className='para-section'>
                <h2>2. Responsibilities of the HCP</h2>
                <p>By participating in this program, you agree to:</p>
                <ol>
                    <li>2.1 Provide timely and accurate input for all studies, research, and educational activities.</li>
                    <li>2.2 Act in a professional and ethical manner while representing DocPro in any capacity.</li>
                    <li>2.3 Maintain the confidentiality of all proprietary or sensitive information shared by DocPro.</li>
                    <li>2.4 Disclose any potential conflicts of interest that may arise during your participation.</li>
                </ol>
            </div>

            <div className='para-section'>
                <h2>3. Reimbursement Policy</h2>
                <ol>
                    <li>3.1 DocPro will reimburse reasonable travel and accommodation expenses incurred for specific programs, as agreed in advance.</li>
                    <li>3.2 All reimbursements are subject to prior approval by DocPro and require submission of valid receipts.</li>
                    <li>3.3 Reimbursement claims must be submitted within [insert number] days of incurring the expense.</li>
                    <li>3.4 No compensation, honorarium, or additional payments will be provided for participation in the program.</li>
                </ol>
            </div>

            <div className='para-section'>
                <h2>4. Confidentiality</h2>
                <p>By agreeing to these terms, you commit to maintaining strict confidentiality regarding all information shared by DocPro, including but not limited to research data, proprietary content, and educational materials.</p>
            </div>

            <div className='para-section'>
                <h2>5. Intellectual Property</h2>
                <p>Any intellectual property created during your participation, such as educational videos or content, will remain the exclusive property of DocPro.</p>
            </div>

            <div className='para-section'>
                <h2>6. Term and Termination</h2>
                <ol>
                    <li>6.1 This agreement is valid from the date of your acceptance until terminated by either party.</li>
                    <li>6.2 You or DocPro may terminate participation at any time by providing written notice.</li>
                </ol>
            </div>

            <div className='para-section'>
                <h2>7. General Provisions</h2>
                <ol>
                    <li>7.1 Your participation is voluntary, and you may decline participation in any specific program by informing DocPro in advance.</li>
                    <li>7.2 This agreement does not establish any form of employment, partnership, or agency relationship between you and DocPro.</li>
                </ol>
            </div>
            <p>By checking, you confirm that you have read, understood, and agreed to be bound by the terms and conditions outlined above.</p>
        </div>
    );
}

export default TermsOfUse;
